export default __webpack_public_path__ + "static/media/image_login.bcf19b09.png";